<ngx-spinner
bdColor="rgba(51, 51, 51, 0.8)"
  template="<img class='loader-style-view' src='assets/images/abhi_loader.gif'  />"
  
>
</ngx-spinner>

<app-header *ngIf="showHeader"></app-header>

<!-- main app container -->
<div class="app-container pad-left-right"  >
   
    <router-outlet></router-outlet>
</div>